import React from 'react';
import Component from '../../../ui-components/Component';
import { withTranslations, withResizer } from '../../../HoCs';
import Page from '../../../ui-components/Page';
import Network, { forceLogout } from '../../../services/Network';
import Styles from './styles';
import stageMap from './config';
import { getQueryParams, path, merge, isEmptyString } from '../../../utils';
import Tab from './Components/Tab';
import { centerAbs, secondary, secondaryOutline } from '../../../resources/styles';
import { CircularProgress } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import view from '../../../Enums';
import {getWorkFlowStyle} from './dataSpecificStyles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIos from '@material-ui/icons/ArrowForwardIos';
import ButtonBase from '@material-ui/core/ButtonBase';
import BackIcon from '../../../resources/vectors/BackIcon'
import Dialog from '@material-ui/core/Dialog';

import pages, { getRouteForPage } from '../../../PageEnums';
import { Link } from 'react-router-dom';
import CyclicFooter from '../../../ui-components/Banners/CyclicFooter';
import { GrowTransition, showInfoSnack } from '../../../ui-components/utils';
import IconButton from '../../../ui-components/Button/Icon';
import { CloseRounded } from '@material-ui/icons';
import {reasonMap} from '../../../config/translationCofing';
import { hmsSelfOnboardingEnabled } from '../../../config/countryConfig';


class PropertyDetails extends Component{

    queryParams = getQueryParams();
    translation_key = 'properties_translations';
    styles = Styles;
    
    getViewMode = () => (this.getWidth() > 654) ? (this.getWidth() > 1023)?view.DESKTOP : view.TAB : view.MOBILE;
    
    
    renderError = () => <React.Fragment>
        <div style={this.gs('error_title')}>{this.gc('something_went_wrong')}</div>
        <div style={this.gs('error_desc')}>{this.gc('Click')}&nbsp;<div style={this.gs('error_action')} onClick={this.networkCall}>{this.gc('here')}</div>&nbsp;{this.gc('to_retry')}</div>
    </React.Fragment>;
    
    state = {
        currentStage:stageMap['property_information'],
        currentElementIdx:0,
        loader:true,
        error:false,
        stages:[],
        propertyInfo:{},
        helpDialogOpen: false,
        leadClosedDialog:false,
        errorMsg:''
    };
    
    componentDidMount() {
        if (hmsSelfOnboardingEnabled()) forceLogout();
        else {
            this.networkCall();
            if (path(this.queryParams, 'show_help', 'false') == 'true')
                this.setState({ helpDialogOpen: true });
            
        }
    }
    
    networkCall = () => {
        // find the first stage that is in progress and set it as current element
        let property_id = this.props.match.params['id'];
    
        this.setState({error:false,loader:true});
        if(property_id != null){
            Network.GET(`v1/oam/property_funnel/${property_id}`,null,{},(d)=> {
                this.setState({loader:false,stages:d.work_flow_cards,property_info:d.property_info})
            },this.onPageRenderError);
        }else{
            // call onError
            this.onPageRenderError("No property ID found")
        }
    };
    
    onPageRenderError = (error,errorCode) => {
        // TODO: remove error code hard coding everywhere
        if(errorCode == 423){
            let key = error && error.error;
            this.setState({leadClosedDialog:true,errorMsg:reasonMap[key] || key})
        }else this.setState({error:true,loader:false})
    };
    
    isCurrentStage = (element) => path(stageMap,`${path(element,'section_type','')}.key`,null) === path(this,`state.currentStage.key`,-1);
    
    changeTab = (idx) => {this.setState({currentStage:stageMap[path(this.state.stages,`${idx}.section_type`,'')],currentElementIdx:idx})};
    
    renderStateButton = () => {
        // use current element to render this.
        let section_state = path(this.state.stages,`${this.state.currentElementIdx}.section_state`)
        if(this.state.currentElementIdx != null) return <ButtonBase style={{marginLeft:'auto'}}><div style={{...this.gs('state_button'),...getWorkFlowStyle(section_state)}}>{section_state}</div></ButtonBase>;
        return null
    };
    
    confirmStage = (stage_section_type) => {
        return path(this.state.currentStage,'key',null) == stageMap[stage_section_type].key
    };
    
    getTranslationByIndex = idx => {
        let section_type = path(this.state.stages,`${[idx]}.section_type`,'');
        return path(stageMap,`${section_type}.translation`)
    };
    
    render = () => <Page title={this.gc('property_details')} contentStyle={{position:'relative',display:'flex',flexDirection:'column'}} menu={false} renderFooter={() => <CyclicFooter style={this.gs('footer')} />}>
        
        {!this.state.loader && !this.state.error && <React.Fragment>
            
            <div style={this.gs('title_slider_container')} className='hideScrollbar'>
                {this.state.stages.map( (element,idx) => {
                    let isSelected = this.isCurrentStage(element);
                    return <Tab
                            onClick={() => {
                                this.changeTab(idx)
                            }}
                            viewMode={this.getViewMode()}
                            isSelected={isSelected}
                            element={element}
                            idx={idx}
                            renderLine={idx!=this.state.stages.length-1}
                            marginLeft={(idx==0 && this.getViewMode()==view.MOBILE)?32:0}
                            marginRight={(idx+1==path(this.state.stages,'length',-1) && this.getViewMode()==view.MOBILE)?32:0}
                            gc={this.gc}
                        />
                })}
            </div>
    
            <div style={this.gs('page_container')}>
                
                <div style={this.gs('tab_head_parent')}>
                    
                    
                    <div style={this.gs('tab_back_child')}>
                        <Link
                            style={this.gs('back_wrapper')}
                            to={getRouteForPage(pages.PROPERTIES)}
                        >
                            <BackIcon  style={this.gs('back')}  className='hover'/>
                        </Link>
                        {this.getViewMode() != view.MOBILE && this.gc('back_to_listing')}
                    </div>
    
                    <div style={this.gs('tab_heading_container')}>
                        <div style={this.gs('tab_heading')}>{path(this.state.currentStage,'translation','')}</div>
                        {this.getViewMode() != view.MOBILE && <div style={this.gs('tab_head_sub')}>{path(this.state.property_info,'property_name','')}</div>}
                    </div>
                    
                    {this.renderStateButton()}
                    
                    
                </div>
                
                <div style={this.gs('tab_content_container')}>
                    
                    {stageMap[path(this.state.stages,`${[this.state.currentElementIdx]}.section_type`,'')].getTabContent(this.getViewMode(), { propertyInfo: this.state.propertyInfo,propertyID:this.props.match.params['id'] })}
                    
                </div>
                
                <div style={{display:'flex'}}>
                    
                    <div style={this.gs('back_container')}>
                       {this.state.currentElementIdx >= 1 && <ButtonBase> <div
                           className='hover noselect'
                           style={this.gs('change_tab_back')}
                           onClick={() => {
                               let targetIdx = this.state.currentElementIdx-1;
                               this.changeTab(targetIdx)
                           }}
                       >
                            <ArrowBackIosIcon style={this.gs('arrow_icon')}/>
                            <span>{this.getViewMode() == view.MOBILE? this.gc('prev_step') :this.gc('Prev')+': '+this.getTranslationByIndex(this.state.currentElementIdx-1)}</span>
                        </div></ButtonBase>}
                    </div>
                    
                    <div style={this.gs('forward_container')} >
                        {this.state.currentElementIdx < this.state.stages.length-1 &&<ButtonBase
                            style={this.gs('change_tab_forward')}
                            onClick={() => {
                                let targetIdx = this.state.currentElementIdx+1;
                                this.changeTab(targetIdx)
                            }}
                        >
                            {this.getViewMode() == view.MOBILE? this.gc('next_step' ):this.gc('Next')+': '+this.getTranslationByIndex(this.state.currentElementIdx+1)}
                            <ArrowForwardIos style={this.gs('arrow_icon')}/>
                        </ButtonBase>}
                    </div>
                    
                </div>
                
                <div style={{height: 200}} />
            </div>

            
            
        </React.Fragment>}
    
        <div style={centerAbs}>
            {this.state.loader && <CircularProgress/>}
            {this.state.error && !this.state.loader && this.renderError()}
        </div>
        
        <Dialog maxWidth='sm' open={this.state.helpDialogOpen} TransitionComponent={GrowTransition} onClose={() => this.setState({ helpDialogOpen: false })}>
            <div style={this.gs('dialog_header')}>
                <div style={this.gs('dialog_title')}>{this.guc('congratulations')}{'!!'}</div>
                <IconButton onClick={() => this.setState({ helpDialogOpen: false })}><CloseRounded /></IconButton>
            </div>
            <div style={this.gs('dialog_content')}>
                {this.guc('an_oyo_representative')}
            </div>
        </Dialog >
    
        <Dialog maxWidth='sm' open={this.state.leadClosedDialog} TransitionComponent={GrowTransition}>
            <div style={this.gs('dialog_header')}>
                <div style={this.gs('dialog_title')}>This lead has been closed</div>
                <Link to={getRouteForPage(pages.PROPERTIES)}><IconButton><CloseRounded /></IconButton></Link>
            </div>
            <div style={this.gs('dialog_content')}>
                {isEmptyString(this.state.errorMsg)? 'Lead is Closed':this.state.errorMsg}
            </div>
        </Dialog >
        
    </Page>
}

export default withTranslations(withResizer(PropertyDetails))
